import app from '../../angular_app.es6';
import { waitingForEnableNextButton, waitingForDisableNextButton } from "../logic/react_interaction";

app.controller('VideoAdAdceptController', [ '$scope', '$rootScope', '$timeout', 'Notification',
  ($scope, $rootScope, $timeout, Notification) => {
    $scope.init = (data, errors) => {
      if (errors) {
        Notification.error(errors)
      }

      waitingForEnableNextButton(data.id, $timeout, () => {
        $rootScope.$broadcast('enableNavButtons');
      });
      waitingForDisableNextButton(data.id, $timeout, () => {
        $rootScope.$broadcast('disableNavButtons');
      });
    };

    // private

    $scope.$on('project-form-next-step', (event) => {
      const form = $('#exercise_form');
      form.submit();
    });
  } ]);
